<!--
하나씩 순차적으로 일괄작업을 실행하는 mixin
------------------------------------
-->
<script>
    export default {
        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,
        },
        data: function () {
            
            return {
                /**
                 * 현재 작업진행상태 
                 *  - none : 작업 초기화되지 않은상태 (모달창 뜨지 않음)
                 *  - ready : 작업 대기중
                 *  - doing : 진행중
                 *  - done : 완료
                 */
                jobState: 'ready',

                /**
                 * 작업대상 (작업상태 와 실제 작업대상이되는 아이템정보를 가진다.)
                 *  - 작업이 초기화될때, 작성된다.
                 * [
                 *  {state: 'success', job_msg: '작업관련 메세지(성공/실패)', item: {실제아이템정보}, next: {다음아이템포인터}},
                 *  {state: 'fail', ...},
                 *  {state: 'doing', ...},
                 *  {state: 'ready', ...},
                 * ]
                 */
                jobTargets: [],
            };
        },
        computed: {
            // 작업대상 전체 카운트
            targetCount() {
                return this.jobTargets.length;
            },

            // 작업성공 카운트
            successCount() {
                return _.filter(this.jobTargets, ['state', 'success']).length;
            },

            // 작업실패 카운트
            failCount() {
                return _.filter(this.jobTargets, ['state', 'fail']).length;
            },
        },
        methods: {
            // 작업초기화 완료 후 모달창 띄우기 바로직전에 호출됨. (사용 컴포넌트에서 재정의 필요)
            jobInitialized() {
                console.log('jobInitialized');
            },

            // 작업초기화 (모달창이 띄워지는 순간 초기화작업)
            jobInit() {
                // 진행상태
                this.jobState='ready';

                // 작업대상아이템 배열작성
                let targets = _.map(this.batch.checked_items, item => {
                    return {
                        state: 'ready',
                        job_msg: null,
                        item: item
                    };
                });

                // 작업대상 아이템에 next 연결
                for (let i=0; i < targets.length; i++) {
                    let curr = targets[i];
                    let next = targets[i+1];
                    curr.next = next ? next : null; // 다음아이템없으면 널
                    curr.prev = i > 0 ? targets[i-1] : null;
                }
                this.jobTargets = targets;
                //console.log(this.jobTargets);

                // 컴포넌트에서 재정의된 초기화작업 호출
                if (this.jobInitialized) {
                    this.jobInitialized();
                }


                // 모달창
                UIkit.modal(this.$el).show();
            },

            // 작업시작
            jobStart() {
                // 컨펌처리
                if (! this.prepareJobStart()) {
                    return;
                }

                // 진행상태
                this.jobState='doing';

                // 첫번째 작업대상의 작업실행
                this.workOneTarget(this.jobTargets[0]);
            },

            /**
             * (실제 사용처에서 재정의)
             *
             * 작업시작 준비단계
             * - 값 검증
             * - 컨펌 처리
             * @return boolean
             */
            prepareJobStart() {
                // 컨펌
                return confirm(this.targetCount+' 개 상품의 정보가 변경됩니다. 정말 실행합니까?')

            },

            // 작업완료
            jobDone() {
                // 진행상태
                this.jobState='done';
            },

            /**
             * 하나의 작업대상에 대한 작업을 실행
             * @param target 작업대상 (jobTargets 배열의 아이템)
             */
            workOneTarget(target) {

                // promise 실행
                this.getWorkPromise(target)
                    .then((job_msg) => {
                        // 성공으로 설정
                        target.state = 'success';
                        target.job_msg = job_msg;

                    })
                    .catch((job_msg) => {
                        // 실패로 설정
                        target.state = 'fail';
                        target.job_msg = job_msg;

                    })
                    .finally(() => {
                        // 다음타겟 호출
                        let next = this.findNextTargetToWork(target);
                        if (next) {
                            this.workOneTarget(next);
                        } else {
                            // 다음없으면, 전체작업 완료처리
                            this.jobDone();
                        }
                    });
            },

            /**
             * getWorkPromise(target)
             * mixin 을 상속받는 컴포넌트에서 정의 필요함.
             * 1개 작업을 실행하는 Promise를 반환함.
             *  - resolve(job_msg) {}
             *  - reject(job_msg) {}
             *
             * @param target 작업대상 (jobTargets 배열의 아이템)
             * @return Promise
             */
            // getWorkPromise(target) {},

            /**
             * 주어진 target 으로부터 작업을 위한 다음 target을 반환
             * @return 다음타겟이 없으면 null반환
             */
            findNextTargetToWork: function (target) {
                let next = target.next;

                if (! next) {
                    return null;
                }

                //console.log(next.item.id+':'+next.state);
                if (next.state === 'ready') {
                    // 대기상태만 반환
                    return next;
                } else {
                    // 다음 타겟이 대기상태가 아니면, 계속 넘김
                    return this.findNextTargetToWork(next);
                }
            },

            /**
             * [TASK-148] 현재페이지 갱신 (기본 구현)
             *  - 컴포넌트에서 refreshPage 를 재정의하면 컴포넌트 정의가 우선 적용된다. (기존 컴포넌트 동작 불변)
             *  - 신규 컴포넌트는 재정의 없이 사용 가능
             */
            refreshPage() {
                $.app.refresh();
            },

            /**
             * [TASK-148] 건당 ajax 요청 Promise 래퍼 (신규 컴포넌트에서 사용)
             *  - 기존 컴포넌트의 getWorkPromise 상용구 (new Promise + $.app.ajax.module.default + success/alert_error_msg) 를 대체
             *  - success : resolve(response) — 응답 전체를 반환하므로 호출측에서 response.success 등을 판정
             *  - 실패 : reject(msg)
             *      msg 우선순위 = 응답 본문(JSON)의 msg → 공용 ajax 모듈이 만든 문구
             *      (공용 모듈은 HTTP 500 만 본문을 문구로 쓰고 그 외 422 등은 "통신에 실패하였습니다" 로 뭉개므로 error 콜백에서 본문을 우선 확인)
             *  - 공용 모듈 기본 동작인 alert() 는 띄우지 않는다. (건마다 얼럿이 뜨는 것 방지 — 실패는 건별 결과 표에 표시)
             *
             * @param {Object} opts $.ajax 옵션 (type, url, data, ...)
             * @return Promise
             */
            ajaxWorkPromise(opts) {
                return new Promise((resolve, reject) => {
                    // 공용 모듈이 만든 오류 문구 보관 (alert 대신)
                    let module_msg = null;

                    let ajax_opts = $.extend({}, opts, {
                        success: (response, textStatus, jqXHR) => {
                            resolve(response);
                        },
                        alert_error_msg: (msg) => {
                            module_msg = msg;
                        },
                        error: (jqXHR, textStatus, errorThrown) => {
                            let json = jqXHR.responseJSON;
                            if (! json && jqXHR.responseText) {
                                try {
                                    json = JSON.parse(jqXHR.responseText);
                                } catch (e) {
                                    json = null;
                                }
                            }
                            reject(json && json.msg ? json.msg : module_msg);
                        },
                    });

                    $.app.ajax.module.default(ajax_opts);
                });
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>